export default "__VITE_ASSET__CDsTV$zc__"